import { createContext, useContext } from 'react';
import { TinyMCE } from '../../types';

type EditorContextState = {
  editor: TinyMCE | null;
  setEditor: (editor: TinyMCE) => void;
};

export const defaultState: EditorContextState = {
  editor: null,
  setEditor: () => null,
};

export const EditorContext = createContext(defaultState);

export const useEditorContext = () => useContext(EditorContext);
